import { dashboardAPI } from "@/services";
import moment from "moment";

export default {
  getGroups() {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.getGroups().then((response) => {
      return response;
    });
  },

  getEvents() {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.getEvents().then((response) => {
      return response;
    });
  },

  getProducts(context, payload) {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.getProducts(payload).then((response) => {
      return response;
    });
  },

  getLayouts(context, payload) {
    const api = dashboardAPI.getLayoutsAPI();
    return api.getLayouts(payload).then((response) => {
      return response;
    });
  },

  postLayouts(context, payload) {
    const api = dashboardAPI.postLayoutsAPI();
    return api.postLayouts(payload).then((response) => {
      return response;
    });
  },

  // New layout management actions
  async initializeLayout(
    context,
    { layoutData, eventId, stallholderId, action = "create" }
  ) {
    try {
      // Set the action type
      context.commit("setLayoutAction", action);

      // Load available data
      await Promise.all([
        context.dispatch("loadAvailableProducts", { eventId, stallholderId }),
        context.dispatch("loadAvailableColors"),
      ]);

      // Initialize the layout
      const layout = {
        LayoutId: layoutData?.LayoutId || "",
        LayoutName: layoutData?.LayoutName || "",
        Stalls: layoutData?.Stalls || [],
        Objects: layoutData?.Objects || [], // Start with empty array
      };

      context.commit("setCurrentLayout", layout);
      context.commit("setEditingPath", []); // Start at root level

      return layout;
    } catch (error) {
      console.error("Error initializing layout:", error);
      throw error;
    }
  },

  async loadAvailableProducts(context, { eventId, stallholderId }) {
    try {
      const response = await context.dispatch("getProducts", {
        EventId: eventId,
        StallholderId: stallholderId,
      });
      context.commit("setAvailableProducts", response.Products || []);
      return response.Products;
    } catch (error) {
      console.error("Error loading products:", error);
      context.commit("setAvailableProducts", []);
      return [];
    }
  },

  async loadAvailableColors(context) {
    try {
      const colors = await context.dispatch("getColours");
      context.commit("setAvailableColors", colors || []);
      return colors;
    } catch (error) {
      console.error("Error loading colors:", error);
      context.commit("setAvailableColors", []);
      return [];
    }
  },

  async saveLayout(context, { eventId, stallholderId, stalls }) {
    try {
      const state = context.state;
      const layout = state.currentLayout;

      const payload = {
        Type: "Layout",
        Action: state.layoutAction,
        StallholderId: stallholderId,
        EventId: eventId,
        LayoutName: layout.LayoutName,
        Stalls: stalls,
        Layout: {
          Objects: layout.Objects.filter(
            (obj) => obj && Object.keys(obj).length > 0
          ),
        },
      };

      // Add LayoutId if updating
      if (state.layoutAction === "update" && layout.LayoutId) {
        payload.LayoutId = layout.LayoutId;
      }

      const response = await context.dispatch("postLayouts", payload);

      // Refresh event metadata after successful save
      await context.dispatch("getEventMetadata", eventId);

      return response;
    } catch (error) {
      console.error("Error saving layout:", error);
      throw error;
    }
  },

  getDevices(context, payload) {
    const api = dashboardAPI.getDevicesAPI();
    return api.getDevices(payload).then((response) => {
      return response;
    });
  },

  postDevices(context, payload) {
    const api = dashboardAPI.postDevicesAPI();
    return api.postDevices(payload).then((response) => {
      return response;
    });
  },

  createColour(context, payload) {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.createColour(payload).then((response) => {
      return response;
    });
  },

  getColours() {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.getColours().then((response) => {
      return response;
    });
  },

  getPortalUsers() {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.getPortalUsers().then((response) => {
      return response;
    });
  },

  createPortalUsers(context, payload) {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.createPortalUsers(payload).then((response) => {
      return response;
    });
  },

  getRecentevent(context, payload) {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.getRecentevent(payload).then((response) => {
      return response;
    });
  },

  getEventsByYear(context, payload) {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.getEventsByYear(payload).then((response) => {
      const sortedEvents = response.sort((a, b) =>
        a.EventName.localeCompare(b.EventName)
      );
      return sortedEvents;
    });
  },

  getEventMetadata(context, payload) {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    // THIS IS A MASSIVE TODO: Rewrite all components to use the currentStallholder and currentStall variables. Instead of EACH component having a watch on globalEventFilter to set individual variables.
    return api.getEventMetadata(payload).then((response) => {
      // FILTERS STORE SHOULD BE FOR THE SALES REPORTS

      console.log("response", response);

      const eventEndDate = moment(
        response.endDateTime,
        "YYYYMMDDHHmm"
      ).toDate();
      const oneDayAgo = new Date();
      oneDayAgo.setDate(oneDayAgo.getDate() - 1);
      let endDateTime = "notSet";

      // If the event is more than 1 day old, set the end date as this keeps changing for in progress events
      if (eventEndDate < oneDayAgo) {
        endDateTime = response.endDateTime;
      }

      // CLEAR ALL FILTERS IF WE GET A NEW EVENT
      context.commit("filter/setSearchStartTime", response.startDateTime, {
        root: true,
      });
      context.commit("filter/setSearchEndTime", endDateTime, { root: true });
      context.commit("filter/setSearchStallholders", "notSet", { root: true });
      context.commit("filter/setSearchStalls", "notSet", { root: true });
      context.commit("filter/setSearchTerminals", "notSet", { root: true });

      context.commit(
        "filter/setAllStalls",
        response.Stallholders.map((stallholder) => stallholder.Stalls).flat(),
        { root: true }
      );
      context.commit("filter/setAllStallHolders", response.Stallholders, {
        root: true,
      });
      context.commit("filter/setAllVouchers", response.Vouchers || [], {
        root: true,
      });
      context.commit("filter/setGlobalEventFilter", response, {
        root: true,
      });
      // ADMIN STORE SHOULD BE FOR THE ADMIN VUES
      // We set the current event, stallholder and stall here so that we can use them in the admin vues. Saves EVERY component from having a watch on globalEventFilter to set individual variables.

      // Capture the old event ID before updating state
      const currentEventId = context.state.currentEvent.EventId;
      const newEventId = response.EventId;

      context.commit("setCurrentEvent", response);
      context.commit("setCurrentStallHolders", response.Stallholders);
      context.commit("setCurrentStallTags", response.StallTags || []);

      // Only update current stallholder and stall if this is a different event

      if (currentEventId !== newEventId) {
        // Different event - reset to first stallholder and stall
        const firstStallholder =
          response.Stallholders && response.Stallholders[0];
        context.commit("setCurrentStallholder", firstStallholder || null);
        context.commit("setCurrentStalls", firstStallholder?.Stalls || null);

        const firstStall =
          firstStallholder &&
          firstStallholder.Stalls &&
          firstStallholder.Stalls[0];
        context.commit("setCurrentStall", firstStall || null);
      } else {
        // Same event - keep current stallholder/stall but update stalls list
        const currentStallholder = context.state.currentStallholder;
        if (currentStallholder && currentStallholder.StallholderId) {
          // Find the updated stallholder data from the response
          const updatedStallholder = response.Stallholders?.find(
            (sh) => sh.StallholderId === currentStallholder.StallholderId
          );
          if (updatedStallholder) {
            context.commit(
              "setCurrentStalls",
              updatedStallholder.Stalls || null
            );
          }
        }
      }
      // We also need to do the same in Login RecentEvent

      // context.commit('allEventsByYear', response)
      return response;
    });
  },

  createEvent(context, payload) {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.createEvent(payload).then((response) => {
      return response;
    });
  },

  createCategories(context, payload) {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.createCategories(payload).then((response) => {
      return response;
    });
  },

  getEventsData(context, payload) {
    const api = dashboardAPI.getAdminGroupsEventsAPI();
    return api.getEventsData(payload).then((response) => {
      return response;
    });
  },
};
